import Link from './Link'
import Embed from './Embed'
import Facebook from './Facebook'
import LinkedIn from './LinkedIn'
import Twitter from './Twitter'

export default [ Link, Embed, Facebook, LinkedIn, Twitter ];